module.exports = function() {
  return new Worker(__webpack_public_path__ + "c9b4f7ec1d90e1f7de85.worker.js");
};